<div class="modal-body">
  <div id="modal-header-wrapper">
    <h2 id="title-text">Définir une nouvelle tâche</h2>
  </div>

  <div *ngIf="task" id="modal-content-wrapper">

    <div class="form-row-wrapper">
      <div class="form-field input-row required">
        <label>Type de tâche</label>
        <div class="task-type-container">
          <div class="task-type-button-wrapper">
            <button [class]="getClassTaskTypeButton('NOTHING')" (click)="task.targetType = 'NOTHING'">
              <i-bs name="question" width="28" height="28"></i-bs>
            </button>
            <div>{{ getLabelTaskTargetType('NOTHING') }}</div>
          </div>
          <div class="task-type-button-wrapper">
            <button [class]="getClassTaskTypeButton('PATIENT')" (click)="task.targetType = 'PATIENT'">
              <i i-bs name="person" width="28" height="28"></i>
            </button>
            <div>{{ getLabelTaskTargetType('PATIENT') }}</div>
          </div>
          <div class="task-type-button-wrapper">
            <button [class]="getClassTaskTypeButton('SELECTION_OF_PATIENTS')"
                    (click)="task.targetType = 'SELECTION_OF_PATIENTS'">
              <i i-bs name="people" width="28" height="28"></i>
            </button>
            <div>{{ getLabelTaskTargetType('SELECTION_OF_PATIENTS') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row-wrapper">
      <div class="form-field input-row required">
        <label>Nature de la Tâche</label>
        <select [(ngModel)]="task.type"
                [class.undef-class]="!task.type"
                class="form-control form-select">
          <option [ngValue]="undefined" selected disabled>Sélectionner...</option>
          <option *ngFor="let t of TASK_TYPES" [ngValue]="t">{{ getLabelTaskType(t) }}</option>
        </select>
        <div class="invalid-feedback">
          Veuillez sélectionner une nature de tâche.
        </div>
      </div>
    </div>

    <div class="form-row-wrapper">
      <div class="form-field input-row required">
        <label>Description</label>
        <input id="description-input"
               [(ngModel)]="task.description"
               placeholder="Saisir une courte description"
               class="form-control"
               type="text">
        <div class="invalid-feedback">
          Veuillez saisir une courte description de la tâche
        </div>
      </div>
    </div>

    <div class="form-field input-row">
      <label>
        <span class="mr10px">Délai pour réaliser le tâche</span>
        <ui-switch (change)="changeDelay($event)"
                   [ngModel]="withDelay"
                   [tooltip]="withDelay
               ? 'Cliquer si vous ne souhaitez pas définir de délai de réalisation'
               : 'Cliquer si vous souhaitez définir de délai de réalisation'"
                   checkedLabel="AVEC"
                   checkedTextColor="#FFFFFF"
                   color="#5f78ff"
                   size="small"
                   uncheckedLabel="SANS"></ui-switch>
      </label>
    </div>

    <div *ngIf="withDelay && task.delay" class="form-row-wrapper">
      <div class="form-field input-row">
        <div class="delay-wrapper">
          <div class="delay-value">
            <input [(ngModel)]="task.delay.value"
                   class="form-control"
                   id="delay-value-input"
                   type="number">
          </div>
          <div class="delay-unit">
            <select [(ngModel)]="task.delay.unit"
                    class="form-control form-select">
              <option [ngValue]="undefined" selected disabled>Sélectionner l'unité</option>
              <option *ngFor="let unit of TASK_DURATION_UNITS" [ngValue]="unit">{{ getLabelTaskDelayUnit(unit) }}
              </option>
            </select>
          </div>
        </div>
        <div class="invalid-feedback">
          Veuillez sélectionner un délai.
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button id="cancel-button" (click)="cancel();" type="button"
            class="btn btn-outline-primary btn-outline text-only">
      Annuler
    </button>

    <button id="validate-button" (click)="validate()" [disabled]="!enableValidate()" type="button"
            class="btn btn-primary btn-gradient">
      <ng-container *ngIf="isLoading else validateButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #validateButton>
        Valider
      </ng-template>
    </button>
  </div>
</div>
